import React, {useState, useEffect, useRef, useLayoutEffect} from 'react';
import { useParams } from 'react-router-dom';
import { Button, Card,CardText, ListGroup, ListGroupItem, Carousel, CarouselItem} from 'react-bootstrap';
import { BiLogoImdb } from "react-icons/bi";
import AuthService from "../utils/auth";
import HeroBackground from '../HeroBackground';
import ImageCropModal from '../ImageCropModal';
import Spinner from "../Spinner";

function CrewProfile() {
  const params = useParams();
  console.log("useParams object:", params); 
  const { userId } = params;

  const [crewmember, setCrewmember] = useState(userId); 
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [originalData, setOriginalData] = useState({}); 
  const [isEditing, setIsEditing] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedUnionType, setSelectedUnionType] = useState('');
  const [selectedUnion, setSelectedUnion] = useState('');
  const [selectedLocal, setSelectedLocal] = useState('');
  const [profilePreviews, setProfilePreviews] = useState([]);
  const [isResumeDeleted, setIsResumeDeleted] = useState(false);
  const [residencePreview, setResidencePreview] = useState(null);
  const [isResidenceDeleted, setIsResidenceDeleted] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [positionError, setPositionError] = useState("");
  const [unionTypeError, setUnionTypeError] = useState("");
  const [workRegionError, setWorkRegionError] = useState("");
  const [profileIError, setProfileIError] = useState("");
  const [residenceError, setResidenceError] = useState("");
  const [showAllResumes, setShowAllResumes] = useState(false);


  const [formState, setFormState] = useState({ 
    userId: '',
    email: '', 
    crewmember: '',
    union: '',
    location: '',
    local: '',
    iMDB: '',
    workRegion: [], 
    unionType: [],
    resumes: [{ title: '', year: '', position: '' }],
    resumeP: [],
    residence: [],
    position: [],
    department: [],
    profileI: [],  
   });

   const workRegion = ['Central', 'East', 'Dallas Fort Worth', 'Gulf Coast', 'Panhandle', 'West'];
   const positions = [
    'actor', 'producer', 'executive producer', 'co-executive producer',
    'showrunner', 'unit production manager', 'production coordinator', 'director', 
    'assistant director', '1st assistant director', '2nd assistant director', 
    'camera operator',  'key hair', 'key makeup', 'production accountant',
    '1st assistant accountant', 'writer', 'sound mixer', 'boom operator', 
    'location manager', 'assistant location manager', 'key grip', 'best boy grip', 
    'gaffer', 'best boy electric', 'transportation coordinator', 'picture car coordinator',
    'key set costumer', 'buyer', 'set decorator', 'lead man', 'production designer', 'art director',
    'music supervisor', 'composer', 'spfx coordinator', 'spfx buyer', 'editor', 'assistant editor',
  ];


  const unionType = [
    'DGA', 
    'IATSE 484', 
    'IATSE 600', 
    'TEAMSTERS LOCAL 657', 
    'IATSE 700', 
    'IATSE 797', 
    'LMGI', 
    'PGA',
    'Association of Independent Commercial Producers', 
    'AFS Producer', 
    'SAG AFTRA', 
    'SAG Eligible', 
    'WGA West', 
    'WGA East', 
    'The American Society of Composers, Authors, and Publishers',
    'International Game Developers Association',
    'VES',
    'BMI',
    'None',
  ]

  const texasCities = [
    'Abilene', 'Alice', 'Alpine', 'Amarillo', 'Arlington', 'Austin', 'Atascocita',
    'Baytown', 'Bastrop', 'Beaumont', 'Boerne', 'Brownsville', 'Bryan', 'Burnet',
    'Carrollton', 'Cedar Park', 'College Station', 'Conroe', 'Corpus Christi',
    'Cuero', 'Dallas', 'Del Rio', 'Denton', 'Eagle Pass', 'Edinburg', 'El Paso',
    'Flower Mound', 'Fort Worth', 'Fredericksburg', 'Frisco', 'Georgetown',
    'Gonzales', 'Grand Prairie', 'Grapevine', 'Harlingen', 'Houston', 'Huntsville',
    'Irving', 'Junction', 'Kerrville', 'Killeen', 'Kingsville', 'Kyle', 'Leander',
    'Lewisville', 'Longview', 'Lubbock', 'Lufkin', 'McKinney', 'Mansfield',
    'Marble Falls', 'Mesquite', 'Midland', 'Mission', 'Nacogdoches',
    'New Braunfels', 'North Richland Hills', 'Odessa', 'Pampa', 'Pasadena',
    'Pecos', 'Pharr', 'Plainview', 'Plano', 'Rockport', 'Round Rock',
    'San Angelo', 'San Antonio', 'San Marcos', 'Stephenville', 'Temple',
    'Tyler', 'Uvalde', 'Victoria', 'Waco', 'Waxahachie', 'Wichita Falls',
    'Yoakum', 'N/A'
  ].sort();

  const [cropModalOpen, setCropModalOpen] = useState(false);
const [rawImageSrc, setRawImageSrc] = useState(null);

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    setRawImageSrc(URL.createObjectURL(file));
    setCropModalOpen(true);
  }
};

const handleCropComplete = (croppedBlob) => {
  setFormState((prevState) => {
    const updatedProfileI = [...prevState.profileI, croppedBlob].slice(0, 3);
    return { ...prevState, profileI: updatedProfileI };
  });

  setProfilePreviews((prevPreviews = []) => {
    const newPreview = URL.createObjectURL(croppedBlob);
    return [...prevPreviews, newPreview].slice(0, 3);
  });

  setCropModalOpen(false);
};
  
  useEffect(() => {
    console.log("userId extracted from URL:", userId); 
    const fetchCrewData = async () => {
      try {
        const response = await fetch(`https://second-team-productions.onrender.com/crew/${userId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch crew data');
        }
        const data = await response.json();
        setFormState(data); 
        setIsLoaded(true);
      } catch (error) {
        console.error('Error fetching data:', error);
        setError(error.message);
      }
    };
    
    fetchCrewData();
  }, [userId]);
  
useEffect(() => {
  if (isLoaded) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 100);

    return () => clearTimeout(timeout);
  }
}, [isLoaded]);

  const currentUser = AuthService.loggedIn(); 
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  console.log('Preparing to send form data')
  
  const handleSaveChanges = async () => {  


    if (!formState.position || formState.position.length === 0) {
      console.log("Validation failed: position");
      setPositionError("Position Required");
      return;
    }

    if (!formState.unionType || formState.unionType.length === 0) {
      console.log("Validation failed: position");
      setUnionTypeError("Union/ Guild Affiliation Required.");
      return;
    }

    if (!formState.workRegion || formState.workRegion.length === 0) {
      console.log("Validation failed: position");
      setWorkRegionError("Work Region Required");
      return;
    }

    if (!formState.profileI || formState.profileI.length === 0) {
      console.log("Validation failed: position");
      setProfileIError("Profile Picture Required");
      return;
    }

    if (!formState.residence || formState.residence.length === 0) {
      console.log("Validation failed: position");
      setResidenceError("Proof of Residency Required");
      return;
    }

    if (!formState.location || formState.location.trim() === "") {
      console.log("Validation failed: position");
      setLocationError("Location Required");
      return; 
    }

    if (!formState.crewmember|| formState.crewmember.trim() === "") {
      console.log("Validation failed: position");
      setNameError("Name Required");
      return; 
    }

    if (!formState.email|| formState.email.trim() === "") {
      console.log("Validation failed: position");
      setEmailError("Email Required");
      return; 
    }
  
    setNameError(""); 
    setPositionError(""); 
    setUnionTypeError(""); 
    setWorkRegionError(""); 
    setProfileIError(""); 
    setLocationError("");
    setNameError("");
    setEmailError(""); 
    setResidenceError(""); 

    const formData = new FormData();
  
    formData.append('email', formState.email);
    formData.append('union', formState.union);
    formData.append('location', formState.location);
    formData.append('local', formState.local);
    formData.append('iMDB', formState.iMDB);
    
  
    if (Array.isArray(formState.workRegion)) {
      formState.workRegion.forEach(region => formData.append('workRegion', region));
    } else {
      formData.append('workRegion', formState.workRegion);
    }

    if (Array.isArray(formState.unionType)) {
      formState.unionType.forEach(type => formData.append('unionType', type));
    } else {
      formData.append('unionType', formState.unionType);
    }
  
    if (Array.isArray(formState.position)) {
      formState.position.forEach(pos => formData.append('position', pos));
    } else {
      formData.append('position', formState.position);
    }

  
    if (Array.isArray(formState.resumes)) {
      formState.resumes.forEach((resume, index) => {
        formData.append(`resumes[${index}].title`, resume.title);
        formData.append(`resumes[${index}].year`, resume.year);
        formData.append(`resumes[${index}].position`, resume.position);
      });
    }

    if (Array.isArray(formState.profileI) && formState.profileI.length > 0) {
      formState.profileI.forEach((file, index) => {
        formData.append(`profileI[${index}]`, file);
      });
    }

    if (formState.resumeP) {
      formData.append('resumeP', formState.resumeP);
    }

    if (formState.residence) {
      formData.append('residence', formState.residence);
    }

    if (formState.bio) {
      formData.append('bio', formState.bio);
    }

    if (formState.crewmember) {
      formData.append('crewmember', formState.crewmember);
    }

    
    try {
      const response = await fetch(`https://second-team-productions.onrender.com/crew/${userId}`, {
        method: 'PUT',
        body: formData,
      });

      if (response.ok) {
        setFormState(formState);
        setIsEditing(false);
      } else {
        console.error("Failed to save changes");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  const handlePositionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentPosition = Array.isArray(prevState.position)
        ? prevState.position
        : prevState.position
        ? [prevState.position]
        : []; 

        if (currentPosition.length >= 3) {
          alert("You can only select up to 3 positions.");
          return prevState;
        }
      if (selectedValue && !currentPosition.includes(selectedValue)) {
        return {
          ...prevState,
          position: [...currentPosition, selectedValue],
        };
      }
      return prevState;
    });
  };

  
  const handleRegionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentWorkRegion = Array.isArray(prevState.workRegion)
        ? prevState.workRegion
        : prevState.workRegion
        ? [prevState.workRegion]
        : [];
      if (selectedValue && !currentWorkRegion.includes(selectedValue)) {
        return {
          ...prevState,
          workRegion: [...currentWorkRegion, selectedValue],
        };
      }
      return prevState; 
    });
  };
  
  

  const handleUnionChange = (e) => {
    const selectedValue = e.target.value;
  
    setFormState((prevState) => {
      const currentUnionType = Array.isArray(prevState.unionType)
        ? prevState.unionType
        : prevState.unionType
        ? [prevState.unionType]
        : [];

      if (selectedValue && !currentUnionType.includes(selectedValue)) {
        return {
          ...prevState,
          unionType: [...currentUnionType, selectedValue],
        };
      }
  
      return prevState;
    });
  };

const handleChange = (e) => {
    const { name, value } = e.target;
  
if (name === 'unionType') {
      setFormState((prevState) => {
        const updatedUnionType = prevState.unionType.includes(value)
          ? prevState.unionType
          : [...prevState.unionType, value];
        return {
          ...prevState,
          unionType: updatedUnionType,
        };
      });
     }
     else if (name === 'local') {
      setSelectedLocal(value);
      setFormState({
        ...formState,
        [name]: value,
      });
    } else if (name === 'union') {
      setSelectedUnion(value); 
      setFormState({
        ...formState,
        [name]: value, 
      });
      
    } else {
      setFormState({
        ...formState,
        [name]: value,
      });
    }
  };

  const handleResumeChange = (index, field, value) => {
    const updatedResumes = formState.resumes.map((resume, i) =>
      i === index ? { ...resume, [field]: value } : resume
    );
    setFormState({ ...formState, resumes: updatedResumes });
  };
  
  const addResumeField = () => {
    setFormState({
      ...formState,
      resumes: [...formState.resumes, { title: '', year: '', position: '' }],
    });
  };

  const handleRemovePositionFromTable = (positionToRemove) => {
    const updatedPositions = Array.isArray(formState.position)
      ? formState.position.filter((pos) => pos !== positionToRemove)
      : []; 
  
    setFormState((prevData) => ({
      ...prevData,
      position: updatedPositions,
    }));
  };


  const handleRemoveRegionFromTable = (workRegionToRemove) => {
    const updatedRegions = Array.isArray(formState.workRegion)
      ? formState.workRegion.filter((pos) => pos !== workRegionToRemove)
      : [];
  
    setFormState((prevData) => ({
      ...prevData,
      workRegion: updatedRegions,
    }));
  };

  const handleRemoveUnionTypeFromTable = (unionTypeToRemove) => {
    const updatedUnion = Array.isArray(formState.unionType)
      ? formState.unionType.filter((pos) => pos !== unionTypeToRemove)
      : [];
  
    setFormState((prevData) => ({
      ...prevData,
      unionType: updatedUnion,
    }));
  };

  const handleRemoveResumesFromTable = (indexToRemove) => {
    const updatedResumes = formState.resumes.filter((_, index) => index !== indexToRemove);
    setFormState((prevData) => ({
      ...prevData,
      resumes: updatedResumes,
    }));
  };
  
  const handleRemoveImage = (index) => {
    const updatedProfileI = formState.profileI.filter((_, i) => i !== index);
    setProfilePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setFormState((prevData) => ({
      ...prevData,
      profileI: updatedProfileI,
    }));
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
  
    handleResize();
    window.addEventListener('resize', handleResize);
  
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const handleAddImage = (event) => {
    const newFiles = Array.from(event.target.files).slice(0, 3);
  
    if (newFiles.length > 0) {
      setFormState((prevState) => {
        const updatedProfileI = [...prevState.profileI, ...newFiles].slice(0, 3);
        return {
          ...prevState,
          profileI: updatedProfileI,
        };
      });
  
      const newPreviews = newFiles.map((file) => URL.createObjectURL(file));
      setProfilePreviews((prevPreviews = []) => {
        const existingPreviews = prevPreviews.slice(0, formState.profileI.length);
        return [...existingPreviews, ...newPreviews].slice(0, 3);
      });
    }
  };
  
  const handleDeleteResume = () => {
    setFormState((prevState) => ({
      ...prevState,
      resumeP: null,
    }));
    setIsResumeDeleted(true);
  };
  
const fileInputRef = useRef(null);

const handleUploadResume = (event) => {
  const file = event.target.files[0];
  if (file) {
    setFormState({ ...formState, resumeP: file });
    setIsResumeDeleted(false);
  }
};


  const fileInputRefResidence = useRef(null); 

  const handleResidenceUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFormState({ ...formState, residence: file });
      setIsResidenceDeleted(false);  
    }
  };

  const handleDeleteResidence = () => {
    setFormState((prevState) => ({
      ...prevState,
      residence: null,
    }));
    setIsResidenceDeleted(true);
    console.log('Residence File deleted');
  };

  const canEdit = currentUser && currentUser.userId === userId;

  if (error) {
    return <div>Error: {error}</div>;
  }

 if (!isLoaded) {
  return <Spinner fullPage label="Loading" />;
}
 
  return (
    <div>
      <>
          <>
      <div 
      style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        // marginTop: '10%',
        }}
        >
              <div className='top-card'>
                <div className="row align-items-center" style={{ backgroundColor: 'black' }}></div>
                <div
                // style={{
                //   maxWidth: '1000px',
                // }}
                >
                <h1 className='title-font justify-content-center'
                style={{
                  marginTop: '2%',
                }}
                >
            {isEditing ? (
              <> 
           <input
              className="about-card-edit-name"
             style={{
  background: 'none',
  border: 'none',
  textAlign: 'center',
  caretColor: 'grey',
  width: `clamp(min(500px, 90vw), ${Math.max((formState.crewmember?.length || 1), 3)}ch, 90vw)`,
  boxSizing: 'border-box',
}}
              type="text"
              name="crewmember"
              value={formState.crewmember || ''}
              onChange={handleInputChange}
            />
              
              <CardText>
              {nameError && nameError}
              </CardText>
              </>
            ) : (  
              <div> 
                {formState && formState.crewmember}
            </div>
            )}
           </h1>
          </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '2%' }}>
             <div>
                                
                <div>
                    {formState && (
                     isEditing ? (
                      <div className="flex col-12">
                        <div style={{ display: 'flex', padding: 0, alignItems: 'center', justifyContent: 'center',  }}>
                          {Array.isArray(formState.position) ? (
                            formState.position.map((position, index) => (
                              <h3
                                key={index}
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  marginRight: '15px',
                                  position: 'relative',
                                  marginTop: '5%', }}
                               >
                                <h5 style={{ marginRight: '10px', fontSize: '18px' }}>{position}</h5>
                                <Button
                                className="process-card-text hover-brighten-red"
                                  style={{
                                    backgroundColor: 'rgb(200, 0, 0)',
                                    color: 'white',
                                    border: '2px solid rgba(28, 26, 26, 0.9)',
                                    boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                      0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                      0 12px 24px rgba(0, 0, 0, 0.6),
                                      0 32px 64px rgba(0, 0, 0, 0.5),
                                      0 64px 100px rgba(0, 0, 0, 0.35)
                                    `,
                                    borderRadius: '50%',
                                    marginBottom: "5%",
                                    width: '25px',
                                    height: '25px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    padding: 0,
                                    
                                  }}
                                  onClick={() => handleRemovePositionFromTable(position)}
                                >
                                  X
                                </Button>
                              </h3>
                            ))
                          ) : (
                            <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              marginRight: '15px',
                              position: 'relative',
                            }}
                            >
                              <h5 style={{ marginRight: '10px', fontSize: '18px' }}>{formState.position}</h5>
                              <h3>
                              <Button
                              className="process-card-text hover-brighten-red"
                              style={{
                                backgroundColor: 'rgb(200, 0, 0)',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                                borderRadius: '50%',
                                width: '25px',
                                height: '25px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                padding: 0,
                              }}
                                onClick={() => handleRemovePositionFromTable(formState.position)}
                              >
                                X
                              </Button>
                              </h3>
                            </div>
                          )}
                        </div>
                        <div>
                        <label htmlFor="position">   
                        </label>
                        <h3 style={{ justifyContent: 'center' }}>
                          <div style={{ position: 'relative', display: 'inline-block' }}>
                            <select
                              name="position"
                              value={selectedPosition}
                              onChange={handlePositionChange}
                              id="position"
                              className="form-select about-card-edit"
                                  style={{
                                    WebkitAppearance: 'none',
                                    MozAppearance: 'none',
                                    appearance: 'none',
                                    backgroundImage: 'none',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    color: 'silver',
                                    padding: '5px 30px 5px 10px',
                                    width: '100%',
                                    fontSize: 'clamp(1.1rem, 2.5vw, 1rem)',
                                    textAlign: 'center',
                                  }}
                                  >
                              <option value="">Add Position</option>
                              {positions.map((position) => (
                                <option key={position} value={position}>
                                  {position}
                                </option>
                              ))}
                            </select>
                            <span
                              style={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                pointerEvents: 'none',
                                color: 'silver',
                                fontSize: '0.8rem',
                              }}
                            >
                              ▼
                            </span>
                          </div>
                        </h3>
                        <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                          {positionError && positionError}
                        </CardText>
                      </div>
                      </div>
                    ) : (
                      
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          flexWrap: 'wrap',
                          padding: 0,
                          listStyle: 'none',
                        }}
                      >
                        {Array.isArray(formState.position) ? (
                          formState.position.map((position, index) => (
                            <React.Fragment key={index}>
                              <h5
                                style={{
                                  fontSize: '4vmin',
                                  margin: 0,
                                  padding: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {position}
                              </h5>
                              {index < formState.position.length - 1 && (
                                <h2
                                  style={{
                                    fontSize: '4vmin',
                                    margin: '0 0.1em',
                                    padding: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 'normal',
                                    color: '#999',
                                  }}
                                >
                                  |
                                </h2>
                              )}
                            </React.Fragment>
                          ))
                        ) : (
                          <h5
                            style={{
                              fontSize: '4vmin',
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            {formState.position}
                          </h5>
                        )}
                      </div>
                    
                    )
                  )}
                    </div>
                  </div>
                </div>
                
                  
                {formState && (
                Array.isArray(formState.profileI) ? (
                  formState.profileI.length > 1 && isSmallScreen ? (
                    <div style={{ marginBottom: '5%' }}>
                      <Carousel interval={null}>
                        {formState.profileI.map((profileI, index) => (
                          <Carousel.Item key={index}>
                            <div 
                            style={{ 
                              position: 'relative', 
                              textAlign: 'center', 
                              width: '100%', 
                              maxWidth: '280px', 
                              margin: '0 auto',
                              
                              }}>
                              <Card.Img
                                src={
                                  typeof profileI === "string"
                                    ? profileI
                                    : profilePreviews[index] || URL.createObjectURL(profileI)
                                }
                                alt={`crew image ${index + 1}`}
                                className="img-fluid"
                                style={{
                                  width: '100%',
                                 
                                  height: 'auto',
                                  display: 'block',
                                         
                                        backdropFilter: 'blur(8px)',
                                  WebkitBackdropFilter: 'blur(8px)',
                                  // borderRadius: "30px",
                                  border: '2px solid rgba(28, 26, 26, 0.9)',
                                  boxShadow: `
                                    0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                    0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                    0 12px 24px rgba(0, 0, 0, 0.6),
                                    0 32px 64px rgba(0, 0, 0, 0.5),
                                    0 64px 100px rgba(0, 0, 0, 0.35)
                                  `,
                                }}
                              />
                              {isEditing && (
                                <Button
                                  className="process-card-text hover-brighten-red"
                                  style={{
                                    position: 'absolute',
                                    top: '1px',
                                    right: '1px',
                                    backgroundColor: 'rgb(200, 0, 0)',
                                    color: 'silver',
                                    border: '1px solid rgba(28, 26, 26, 0.9)',
                                    boxShadow: `
                                      0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                      0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                      0 12px 24px rgba(0, 0, 0, 0.6),
                                      0 32px 64px rgba(0, 0, 0, 0.5),
                                      0 64px 100px rgba(0, 0, 0, 0.35)
                                    `,
                                    borderRadius: '50%',
                                    width: '25px',
                                    height: '25px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    padding: 0,
                                    zIndex: 2,
                                  }}
                                  onClick={() => handleRemoveImage(index)}
                                >
                                  X
                                </Button>
                              )}
                            </div>
                          </Carousel.Item>
                        ))}
                      </Carousel>
                      {isEditing && formState.profileI.length < 3 && (
                       <div 
                        style={{
                          marginTop: '4%',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          position: 'relative',
                        }}
                      >
                        <input
                          name="profileI"
                          type="file"
                          id="profileI"
                          accept="image/*"
                          onChange={handleFileSelect}
                          style={{ display: 'none' }}
                        />
                        <label htmlFor="profileI" style={{ cursor: 'pointer', margin: 0 }}>
                          <h3>
                            <Button
                              as="span"
                              className="process-card-text hover-brighten-green"
                              style={{
                                padding: '10px 20px',
                                backgroundColor: 'rgb(0, 128, 0)',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                                borderRadius: '999px',
                                cursor: 'pointer',
                                textAlign: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                              }}
                            >
                              <h5 style={{ margin: '1%' }}>+ Add Image</h5>
                            </Button>
                          </h3>
                        </label>
                        <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                          {profileIError && profileIError}
                        </CardText>
                      </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ display: 'flex', marginBottom: '5%', justifyContent: 'center', flexWrap: 'wrap', gap: '16px'  }}>
                      {formState.profileI.map((profileI, index) => (
                        <div key={index} style={{ flex: '0 0 30%', position: 'relative' }}>
                          <Card.Img
                            src={
                              typeof profileI === "string"
                                ? profileI
                                : profilePreviews[index] || URL.createObjectURL(profileI)
                            }
                            alt={`crew image ${index + 1}`}
                            className="img-fluid"
                              style={{
                                width: '100%',
                                maxWidth: '280px',   // add this
                                margin: '0 auto',
                                height: 'auto',      // was '100%' — let it scale proportionally instead of stretching
                                display: 'block',    
                                backdropFilter: 'blur(8px)',
                                WebkitBackdropFilter: 'blur(8px)',
                                // borderRadius: "30px",
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                              }}
                          />
                          {isEditing && (
                            <h3>
                              <Button
                                className="process-card-text hover-brighten-red"
                                style={{
                                  position: 'absolute',
                                  top: '1px',
                                  right: '1px',
                                  backgroundColor: 'rgb(200, 0, 0)',
                                  color: 'white',
                                  border: '2px solid rgba(28, 26, 26, 0.9)',
                                  boxShadow: `
                                    0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                    0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                    0 12px 24px rgba(0, 0, 0, 0.6),
                                    0 32px 64px rgba(0, 0, 0, 0.5),
                                    0 64px 100px rgba(0, 0, 0, 0.35)
                                  `,
                                  borderRadius: '50%',
                                  width: '25px',
                                  height: '25px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '16px',
                                  fontWeight: 'bold',
                                  padding: 0,
                                  zIndex: 2,
                                }}
                                onClick={() => handleRemoveImage(index)}
                              >
                                X
                              </Button>
                            </h3>
                          )}
                        </div>
                      ))}
                      {isEditing && formState.profileI.length < 3 && (
                      <div style={{
                        flex: '0 0 30%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        position: 'relative',
                      }}>
                        <input
                          name="profileI"
                          type="file"
                          id="profileI"
                          accept="image/*"
                          onChange={handleFileSelect}
                          style={{ display: 'none' }}
                        />
                        <label htmlFor="profileI" style={{ cursor: 'pointer', margin: 0 }}>
                          <h3>
                            <Button
                              as="span"
                              className="process-card-text hover-brighten-green"
                              style={{
                                padding: '10px 20px',
                                marginTop: '10px',
                                backgroundColor: 'green',
                                color: 'white',
                                border: '2px solid rgba(28, 26, 26, 0.9)',
                                boxShadow: `
                                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                  0 12px 24px rgba(0, 0, 0, 0.6),
                                  0 32px 64px rgba(0, 0, 0, 0.5),
                                  0 64px 100px rgba(0, 0, 0, 0.35)
                                `,
                                borderRadius: '999px',
                                cursor: 'pointer',
                                textAlign: 'center',
                              }}
                            >
                              <h5 style={{ margin: '1%' }}>+ Add Image</h5>
                            </Button>
                          </h3>
                        </label>
                        <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                          {profileIError && profileIError}
                        </CardText>
                      </div>
                    )}
                    </div>
                  )
                ) : (
             <div style={{ textAlign: 'center' }}>
              <Card.Img
                src={formState.profileI}
                alt="crew image"
                className="img-fluid"
                style={{
                  width: '100%',
                  maxWidth: '280px',
                  margin: '0 auto',
                  height: 'auto',
                  display: 'block',
                    
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                // borderRadius: "30px",
                border: '2px solid rgba(28, 26, 26, 0.9)',
                boxShadow: `
                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                  0 12px 24px rgba(0, 0, 0, 0.6),
                  0 32px 64px rgba(0, 0, 0, 0.5),
                  0 64px 100px rgba(0, 0, 0, 0.35)
                `,
                      }}
                    />
                  </div>
                      )
                    )}

              <ImageCropModal
                show={cropModalOpen}
                imageSrc={rawImageSrc}
                onCancel={() => setCropModalOpen(false)}
                onCropComplete={handleCropComplete}
              />
                <div>
              </div>
                <div>
                <Card
                    className="p-4 card-body"
                    style={{
                      marginRight: '7%',
                      marginLeft: '7%',
                      marginBottom: '5%',
                      width: 'auto',
                      height: 'auto',
                      display: 'block',
                      boxSizing: 'border-box',
                    }}
                    >
                  
<div className="row gy-4 justify-content-center">          
  <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
  <h5 className="mb-2" style={{justifyContent: 'center' }}>Location</h5>  
  {isEditing ? (
    <> 
      <div style={{ position: 'relative', width: '100%' }}>
        <select
          className="form-select about-card-edit"
            style={{
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              backgroundImage: 'none',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'silver',
              padding: '5px 30px 5px 10px',
              width: '100%',
              fontSize: 'clamp(1.1rem, 2.5vw, 1rem)',
              textAlign: 'center',
            }}
          name="location"
          value={formState.location || ''}
          onChange={handleInputChange}
        >
          <option value="" disabled>Select a city</option>
          {texasCities.map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </select>
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: 'silver',
            fontSize: '0.8rem',
          }}
        >
          ▼
        </span>
      </div>
      <CardText>
        {locationError && locationError}
      </CardText>
    </>
  ) : (
    <CardText style={{ textAlign: 'center' }}>
      <div>
        {formState && formState.location}
      </div> 
    </CardText>
  )}                             
</div>
                {/* Work Region */} 
              {formState && (
  isEditing ? (
    <> 
      <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
        <h5 className="mb-2" style={{justifyContent: 'center' }}>Work Region(s)</h5>

        <div style={{ position: 'relative', width: '100%' }}>
                     
          <select    
          htmlFor="workRegion"                    
            name="workRegion"
            value={selectedRegion}
            onChange={handleRegionChange}
            id="workRegion"
            className="form-select about-card-edit"
            style={{
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              backgroundImage: 'none',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'silver',
              padding: '5px 30px 5px 10px',
              width: '100%',
              fontSize: 'clamp(1.1rem, 2.5vw, 1rem)'
            }}
          >
            <option value="" style={{ textAlign: 'center' }}>Add Region</option>
            {workRegion.map((workRegion) => (
              <option key={workRegion} value={workRegion}>
                {workRegion}
              </option>
            ))}
          </select> 
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              color: 'silver',
              fontSize: '0.8rem',
            }}
          >
            ▼
          </span>
        </div>

        <CardText>
          {workRegionError && workRegionError}
        </CardText>

        <ListGroup className="w-100">
          {Array.isArray(formState.workRegion) ? (
            formState.workRegion.map((workRegion, index) => (
              <ListGroupItem
                className="position-relative" 
                key={index}
                style={{
                  background: 'none',
                  color: 'silver',
                  fontSize: '1rem',
                  border: 'none',
                  textAlign: 'center',                           
                }}
              >
                {workRegion}  
                <h3>
                  <Button
                    className="process-card-text hover-brighten-red"
                    size="sm"
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      backgroundColor: 'rgb(200, 0, 0)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      padding: 0,
                    }}
                    onClick={() => handleRemoveRegionFromTable(workRegion)}
                  >
                    X 
                  </Button>
                </h3>
              </ListGroupItem>
            ))
          ) : (
            <ListGroupItem
              className="position-relative"          
              style={{
                background: 'none',
                color: 'silver',
                fontSize: '1rem',
                border: 'none',
                textAlign: 'center',                           
              }}
            >
              {formState.workRegion}
              <h3>
                <Button
                  className="process-card-text hover-brighten-red"
                  size="sm"
                  style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    backgroundColor: 'rgb(200, 0, 0)',
                    color: 'white',
                    border: '2px solid rgba(28, 26, 26, 0.9)',
                    boxShadow: `
                      0 2px 0 rgba(255, 255, 255, 0.03) inset,
                      0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                      0 12px 24px rgba(0, 0, 0, 0.6),
                      0 32px 64px rgba(0, 0, 0, 0.5),
                      0 64px 100px rgba(0, 0, 0, 0.35)
                    `,
                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    padding: 0,
                  }}
                  onClick={() => handleRemoveRegionFromTable(formState.workRegion)}
                >
                  X
                </Button>
              </h3>
            </ListGroupItem>
          )}
        </ListGroup> 
      </div>
    </>
  ) : (
    <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
      <h5 className="mb-2" style={{justifyContent: 'center' }}>Work Region(s)</h5>
      <div style={{ position: 'relative', width: '100%' }}>          
        <ListGroup className="w-100">
          {Array.isArray(formState.workRegion) ? (
            formState.workRegion.map((workRegion, index) => (
              <ListGroupItem
                key={index}
                className="position-relative" 
                style={{
                  background: 'none',
                  color: 'white',
                  fontSize: '1rem',
                  border: 'none',
                  textAlign: 'center',
                }}
              >
                {workRegion}
              </ListGroupItem>
            ))
          ) : (
            <CardText style={{ textAlign: 'center' }}>
              <div>
                {formState.workRegion}
              </div>
            </CardText>
          )}  
        </ListGroup>     
      </div>
    </div>
  )
)}
                  
      
   <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
  <h5 className="mb-2" style={{justifyContent: 'center' }}>Will Work as a Local</h5>
  <div style={{ position: 'relative', width: '100%' }}>                     
    {isEditing ? (
      <>
        <select
          name="local"
          value={formState.local}
          onChange={handleChange}
          id="local"
          className="form-select about-card-edit"
          style={{
            WebkitAppearance: 'none',
            MozAppearance: 'none',
            appearance: 'none',
            backgroundImage: 'none',
            backgroundColor: 'transparent',
            border: 'none',
            color: 'silver',
            padding: '5px 30px 5px 10px',
            width: '100%',
            fontSize: 'clamp(1.1rem, 2.5vw, 1rem)',
            justifyContent: 'center'
          }}
        >
          {!selectedLocal && (
            <option value="" style={{ textAlign: 'center' }} disabled>
              Select Option
            </option>
          )}
          <option value="Yes" style={{ textAlign: 'center' }}>Yes</option>
          <option value="No" style={{ textAlign: 'center' }}>No</option>
        </select>
        <span
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            color: 'silver',
            fontSize: '0.8rem',
          }}
        >
          ▼
        </span>
      </>      
    ) : (
      <CardText style={{ textAlign: 'center' }}>
        <div>
          {formState && formState.local}
        </div>       
      </CardText>
    )}        
  </div>
</div>      
                   {formState && (
  isEditing ? (
    <>
      <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
        <h5 className="mb-2" style={{justifyContent: 'center' }}>Union / Guild Affiliations</h5>

        <div style={{ position: 'relative', width: '100%' }}>
          <select
            htmlFor="unionType"
            name="unionType"
            value={selectedUnionType}
            onChange={handleUnionChange}
            id="unionType"
            className="form-select about-card-edit"
            style={{
              WebkitAppearance: 'none',
              MozAppearance: 'none',
              appearance: 'none',
              backgroundImage: 'none',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'silver',
              padding: '5px 30px 5px 10px',
              width: '100%',
              fontSize: 'clamp(1.1rem, 2.5vw, 1rem)',
              justifyContent: 'center'
            }}
          >
            <option value="" style={{ textAlign: 'center' }}>Add Union</option>
            {unionType.map((unionType) => (
              <option key={unionType} value={unionType}>
                {unionType}
              </option>
            ))}
          </select>
          <span
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              color: 'silver',
              fontSize: '0.8rem',
            }}
          >
            ▼
          </span>
        </div>

        <CardText>
          {unionTypeError && unionTypeError}
        </CardText>                        

        <ListGroup className="w-100 mt-2">
          {Array.isArray(formState.unionType) ? (
            formState.unionType.map((unionType, index) => (
              <ListGroupItem
                key={index}
                className="position-relative"
                style={{
                  background: 'none',
                  color: 'silver',
                  fontSize: '1rem',
                  border: 'none',  
                  textAlign: 'center',       
                }}
              >
                {unionType}
                <h3>
                  <Button
                    className="process-card-text hover-brighten-red"
                    size="sm"
                    style={{
                      position: 'absolute',
                      top: '5px',
                      right: '5px',
                      backgroundColor: 'rgb(200, 0, 0)',
                      color: 'white',
                      border: '2px solid rgba(28, 26, 26, 0.9)',
                      boxShadow: `
                        0 2px 0 rgba(255, 255, 255, 0.03) inset,
                        0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                        0 12px 24px rgba(0, 0, 0, 0.6),
                        0 32px 64px rgba(0, 0, 0, 0.5),
                        0 64px 100px rgba(0, 0, 0, 0.35)
                      `,
                      borderRadius: '50%',
                      width: '25px',
                      height: '25px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '16px',
                      fontWeight: 'bold',
                      padding: 0,
                    }}
                    onClick={() => handleRemoveUnionTypeFromTable(unionType)}
                  >
                    X
                  </Button>
                </h3>
              </ListGroupItem>
            ))
          ) : (
            <ListGroupItem
              className="position-relative"
              style={{
                background: 'none',
                color: 'silver',
                fontSize: '1rem',
                border: 'none',  
                textAlign: 'center',
              }}
            >
              {formState.unionType}
              <h3>
                <Button
                  className="process-card-text hover-brighten-red"
                  size="sm"
                  style={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px',
                    backgroundColor: 'rgb(200, 0, 0)',
                    color: 'white',
                    border: '2px solid rgba(28, 26, 26, 0.9)',
                    boxShadow: `
                      0 2px 0 rgba(255, 255, 255, 0.03) inset,
                      0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                      0 12px 24px rgba(0, 0, 0, 0.6),
                      0 32px 64px rgba(0, 0, 0, 0.5),
                      0 64px 100px rgba(0, 0, 0, 0.35)
                    `,

                    borderRadius: '50%',
                    width: '25px',
                    height: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    padding: 0,
                  }}
                  onClick={() => handleRemoveUnionTypeFromTable(formState.unionType)}
                >
                  X
                </Button>
              </h3>
            </ListGroupItem>
          )}
        </ListGroup> 
      </div>
    </>   
  ) : (
    <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
      <h5 className="mb-2" style={{justifyContent: 'center' }}>Union / Guild Affiliations</h5>
      <div style={{ display: 'flex', listStyle: 'none', padding: 0 }}> 
        <ListGroup className="w-100">
          {Array.isArray(formState.unionType) ? (
            formState.unionType.map((unionType, index) => (
              <ListGroupItem
                key={index}
                className="position-relative"
                style={{
                  background: 'none',
                  color: 'silver',
                  fontSize: '1rem',
                  border: 'none',
                  textAlign: 'center',
                }}
              >
                {unionType}
              </ListGroupItem>
            ))
          ) : (
            <CardText style={{ textAlign: 'center' }}>
              <div>
                {formState.unionType}
              </div>
            </CardText>      
          )}  
        </ListGroup>                  
      </div>
    </div>
  )
)}
                      </div>  
                  </Card>
                </div>
                {(formState && Array.isArray(formState.resumes) && (formState.resumes.length > 0 || isEditing)) && (
                  <Card
                    className="p-4 card-body"
                    style={{
                      marginRight: '7%',
                      marginLeft: '7%',
                      marginBottom: '5%',
                      width: 'auto',
                      height: 'auto',
                      boxSizing: 'border-box',
                      display: 'block',
                    }}
                  >
                    <h5 className="justify-content-center">credits</h5>

                    {formState &&
                  Array.isArray(formState.resumes) &&
                  formState.resumes
                    .slice(0, isEditing ? formState.resumes.length : showAllResumes ? formState.resumes.length : 3)
                    .map((resume, index) => (
                      <div key={index}>
                        <Card>
                          {isEditing ? (
                            <>
                              <div className="row gy-4 justify-content-center">
                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Position</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="form-control about-card-edit"
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                      type="text"
                                      name={`position-${index}`}
                                      value={formState.resumes[index]?.position || ''}
                                      onChange={(e) =>
                                        handleResumeChange(index, 'position', e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Show</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="form-control about-card-edit"
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                      type="text"
                                      name={`title-${index}`}
                                      value={formState.resumes[index]?.title || ''}
                                      onChange={(e) =>
                                        handleResumeChange(index, 'title', e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Year</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                      className="form-control about-card-edit"
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                      type="text"
                                      name={`year-${index}`}
                                      value={formState.resumes[index]?.year || ''}
                                      onChange={(e) =>
                                        handleResumeChange(index, 'year', e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div>
                                <h3>
                                  <Button
                                    className="process-card-text hover-brighten-red"
                                    style={{
                                      position: 'absolute',
                                      top: '5px',
                                      right: '5px',
                                      backgroundColor: 'rgb(200, 0, 0)',
                                      color: 'white',
                                      border: '2px solid rgba(28, 26, 26, 0.9)',
                                      boxShadow: `
                                        0 2px 0 rgba(255, 255, 255, 0.03) inset,
                                        0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                                        0 12px 24px rgba(0, 0, 0, 0.6),
                                        0 32px 64px rgba(0, 0, 0, 0.5),
                                        0 64px 100px rgba(0, 0, 0, 0.35)
                                      `,
                                      borderRadius: '50%',
                                      width: '25px',
                                      height: '25px',
                                      cursor: 'pointer',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '16px',
                                      fontWeight: 'bold',
                                      padding: 0,
                                    }}
                                    onClick={() => handleRemoveResumesFromTable(index)}
                                  >
                                    X
                                  </Button>
                                </h3>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="row gy-4 justify-content-center" style={{ margin: '.5%' }}>
                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Position</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                    >
                                      <CardText>{resume.position || 'N/A'}</CardText>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Show</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                    >
                                      <CardText>{resume.title || 'N/A'}</CardText>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-10 col-md-4 col-lg-4 d-flex flex-column">
                                  <h5 className="mb-2" style={{ justifyContent: 'center' }}>Year</h5>
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        height: '100%',
                                        width: '100%',
                                        textAlign: 'center',
                                        color: 'silver',
                                        caretColor: 'grey',
                                        fontSize: '1.2rem',
                                      }}
                                    >
                                      <CardText>{resume.year || 'N/A'}</CardText>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </Card>
                        {index < formState.resumes.length - 1 && (
                          <hr
                            style={{
                              borderTop: '3px solid #ccc',
                              boxShadow: '0 0 5px #3d3c3a',
                            }}
                          />
                        )}
                      </div>
                    ))}

                {!isEditing && formState?.resumes?.length > 3 && (
                  <div className="d-flex justify-content-center mt-3">
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowAllResumes(!showAllResumes)}
                      className="process-card-text hover-brighten"
                      style={{
                        display: 'block',
                        height: '40%',
                        width: 'auto',
                        margin: '5px auto',
                        fontSize: '2.5vmin',
                        backgroundColor: 'rgb(67, 66, 66)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        textAlign: 'center',
                        gap: '0.5rem',
                        padding: '0.5rem 1rem',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                        border: '2px solid rgba(28, 26, 26, 0.9)',
                        boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                        borderRadius: '999px',
                        transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s",
                  
                      }}
                    >
                      <h5 style={{ margin: '1%' }}>
                        {showAllResumes ? 'Show Less' : 'Show More'}
                      </h5>
                    </Button>
                  </div>
                )}

               {isEditing ? (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '7%' }}>
                  <Button
                    className="process-card-text hover-brighten-green"
                    variant="link"
                    onClick={addResumeField}
                    style={{
                      backgroundColor: 'rgb(0, 128, 0)',
                      border: '2px solid rgba(28, 26, 26, 0.9)',
                      boxShadow: `
                        0 2px 0 rgba(255, 255, 255, 0.03) inset,
                        0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                        0 12px 24px rgba(0, 0, 0, 0.6),
                        0 32px 64px rgba(0, 0, 0, 0.5),
                        0 64px 100px rgba(0, 0, 0, 0.35)
                      `,
                      borderRadius: '999px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                    }}
                  >
                    <h5 style={{ margin: '1%' }}>Add</h5>
                  </Button>
                </div>
              ) : (
                <div></div>
              )}           
              </Card>
              )}

              {(formState && (formState.resumeP) && (formState.resumeP.length > 0 || isEditing)) || isEditing ? (
                <Card
                  className="card-body"
                  style={{
                    marginTop: '5%',
                    marginBottom: '5%',
                    marginRight: '25%',
                    marginLeft: '25%',
                    width: 'auto',       
                    display: 'block',  
                    overflow: 'hidden',
                    boxSizing: 'border-box', 
                    
                  }}
                >
                  <div className="justify-content-center" style={{ position: 'relative', }}>
                    {formState && formState.resumeP && !isResumeDeleted && !isEditing && (
                      <Button
                        onClick={() => {
                          const link = document.createElement('a');
                          link.href = formState.resumeP;
                          link.download = formState.resumeP.split('/').pop();
                          link.click();
                        }}
                        className="process-card-text hover-brighten"
                        style={{
                          display: 'block',
                          height: '40%',
                          width: 'auto',
                          margin: '5px auto',
                          fontSize: '2.5vmin',
                          backgroundColor: 'rgb(67, 66, 66)',
                          color: '#fff',
                          cursor: 'pointer',
                          textAlign: 'center',
                          gap: '0.5rem',
                          padding: '0.5rem 1rem',
                          border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                          0 2px 0 rgba(255, 255, 255, 0.12) inset,
                          0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                          0 6px 12px rgba(0, 0, 0, 0.5),
                          0 12px 24px rgba(0, 0, 0, 0.35)
                        `,
                          borderRadius: '999px',
                          transition: "opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s", 
                        }}
                      >
                        <h5 style={{ margin: '1%' }}>Download Resume</h5>
                      </Button>
                    )}

                    {formState && formState.resumeP && !isResumeDeleted && isEditing && (
                      <Button
                        onClick={handleDeleteResume}
                        className="process-card-text hover-brighten-red"
                        style={{
                          display: 'block',
                          height: '40%',
                          width: 'auto',
                          margin: '5px auto',
                          fontSize: '2.5vmin',
                          backgroundColor: 'rgb(200, 0, 0)',
                          color: '#fff',
                          border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                            0 2px 0 rgba(255, 255, 255, 0.03) inset,
                            0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                            0 12px 24px rgba(0, 0, 0, 0.6),
                            0 32px 64px rgba(0, 0, 0, 0.5),
                            0 64px 100px rgba(0, 0, 0, 0.35)
                          `,
                          borderRadius: '999px',
                          cursor: 'pointer',
                          textAlign: 'center',
                          
                        }}
                      >
                        <h5 style={{ margin: '1%' }}>Delete Resume</h5>
                      </Button>
                    )}

                    {(!formState || !formState.resumeP || isResumeDeleted) && isEditing && (
                      <div style={{ marginTop: '10px' }}>
                        <Button
                          onClick={() => fileInputRef.current.click()}
                          className="process-card-text hover-brighten-green"
                          style={{
                            display: 'block',
                            height: '40%',
                            width: 'auto',
                            margin: '5px auto',
                            fontSize: '2.5vmin',
                            backgroundColor: 'rgb(0, 128, 0)',
                            color: '#fff',
                            border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                            0 2px 0 rgba(255, 255, 255, 0.03) inset,
                            0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                            0 12px 24px rgba(0, 0, 0, 0.6),
                            0 32px 64px rgba(0, 0, 0, 0.5),
                            0 64px 100px rgba(0, 0, 0, 0.35)
                          `,
                          borderRadius: '999px',
                            cursor: 'pointer',
                            textAlign: 'center',
                          }}
                        >
                          <input
                            ref={fileInputRef}
                            type="file"
                            accept=".pdf,.doc,.docx"
                            style={{ display: 'none' }}
                            onChange={handleUploadResume}
                          />
                          <h5 style={{ margin: '1%' }}>Upload Resume</h5>
                        </Button>
                      </div>
                    )}
                  </div>
                </Card>
              ) : null}           
                
           <Card 
                  className=" card-body "
                  style={{
                    display: 'block',
                    marginRight: '10%',
                    marginLeft: '10%',
                    marginBottom: '5%',
                    width: 'auto',
                    height: 'auto',
                    boxSizing: 'border-box',
                  }}
                  >

                <div className="row gy-4">
                  
                 {isEditing ? (
                    <>
                    <div className="col-12 col-md-6 col-lg-6 d-flex flex-column align-items-start">
                      <h5 className="mb-2" style={{ margin: '1%' }}>Email</h5>
                      <div style={{ position: 'relative', width: '100%', }}>
                      <input
                        className="form-control about-card-edit"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'silver',
                          caretColor: 'grey',
                          width: '100%',
                          fontSize: '1.2rem',
                        }}
                        type="text"
                        name="email"
                        value={formState.email || ''}
                        onChange={handleInputChange}
                      />
                      <CardText>
                       {emailError && emailError}
                      </CardText>
                      </div>
                      </div>
               
                    </>
                  ) : (
                    <>
                <div className="col d-flex flex-column justify-content-center align-items-center">
                  <div style={{ position: 'relative',textAlign: 'center' }}>
                    <a href={`mailto:${formState && formState.email}`}>
                      <Button
                        className="process-card-text hover-brighten"
                        style={{
                          fontSize: '2.5vmin',
                          backgroundColor: 'rgb(67, 66, 66)',
                          border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                            0 2px 0 rgba(255, 255, 255, 0.12) inset,
                            0 -1px 0 rgba(0, 0, 0, 0.45) inset,
                            0 6px 12px rgba(0, 0, 0, 0.5),
                            0 12px 24px rgba(0, 0, 0, 0.35)
                          `,
                          cursor: 'pointer',
                          padding: '1rem',
                          width: '100%',
                        }}
                      >
                        <h5 style={{ margin: '1%', }}>Email</h5>
                      </Button>
                    </a>
                  </div>
                </div>
                    </>
                )}

                    {isEditing ? (
                    <>
                    <div className="col-12 col-md-6 col-lg-6 d-flex flex-column">
                    <div style={{ position: 'relative', width: '100%' }}>
                    <h5 className="mb-2" >iMDB Link</h5>
                      <input
                         className="form-control about-card-edit"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: 'silver',
                          caretColor: 'grey',
                          width: '100%',
                          fontSize: '1.2rem',
                        }}
                        type="text"
                        name="iMDB"
                        value={formState.iMDB || ''}
                        onChange={handleInputChange}
                      />
                    </div>
                    </div>
                    </>
                  ) : (
                    formState && formState.iMDB && (
                    <>
                    
                   <div className="col d-flex flex-column justify-content-center align-items-center">
                    <div style={{ position: 'relative', textAlign: 'center' }}>
                      <a href={formState && formState.iMDB}>
                        <BiLogoImdb
                        
                          style={{
                            color: 'gold',
                            fontSize: '14.5vmin',
                            
                          }}
                        />
                      </a>
                    </div>
                  </div>
                    
                    </>
                    )
                  )}
                  </div>
                

                <div>
                  {isEditing ? (
                   <div className="flex col-12">
                    <div style={{ marginTop: '10%' }}>
                     {formState && formState.residence && !isResidenceDeleted && (
                      <Button
                        onClick={handleDeleteResidence}
                        className="process-card-text hover-brighten-red"
                         style={{
                          display: 'block',
                          height: '40%',
                          width: 'auto',
                          margin: '5px auto',
                          fontSize: '2.5vmin',
                          backgroundColor: 'rgb(200, 0, 0)',
                          color: 'silver',
                          border: '2px solid rgba(28, 26, 26, 0.9)',
                          boxShadow: `
                            0 2px 0 rgba(255, 255, 255, 0.03) inset,
                            0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                            0 12px 24px rgba(0, 0, 0, 0.6),
                            0 32px 64px rgba(0, 0, 0, 0.5),
                            0 64px 100px rgba(0, 0, 0, 0.35)
                          `,
                          borderRadius: '999px',
                          cursor: 'pointer',
                          textAlign: 'center',
                          }}
                           >
                          <h5 style={{ margin: '1%' }}>Replace Residency Doc</h5>
                       </Button>
                        )}                               
                        {(!formState || !formState.residence || isResidenceDeleted) && (
                         <div style={{ marginTop: '10px' }}>
                          <Button
                           onClick={() => fileInputRefResidence.current.click()} 
                           className="process-card-text hover-brighten-green" 
                           style={{
                            display: 'block',
                            height: '40%',
                            width: 'auto',
                            margin: '5px auto',
                            fontSize: '2.5vmin',
                            backgroundColor: 'rgb(0, 128, 0)',
                            color: '#fff',
                            border: '2px solid rgba(28, 26, 26, 0.9)',
                            boxShadow: `
                              0 2px 0 rgba(255, 255, 255, 0.03) inset,
                              0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                              0 12px 24px rgba(0, 0, 0, 0.6),
                              0 32px 64px rgba(0, 0, 0, 0.5),
                              0 64px 100px rgba(0, 0, 0, 0.35)
                            `,
                            borderRadius: '999px',
                            cursor: 'pointer',
                            textAlign: 'center',
                            }}
                             >
                            <input
                             ref={fileInputRefResidence}
                             type="file"
                             accept=".pdf,.doc,.docx"
                             style={{ display: 'none' }}
                             onChange={handleResidenceUpload}
                              />
                            <h5 style={{ margin: '1%' }}>Upload Residency Doc</h5>
                          </Button>
                    </div>
                    )}
                  </div>
                <CardText style={{ textAlign: 'center', color: 'red', marginTop: '1%' }}>
                  {residenceError && residenceError}
                </CardText>
                </div>          
                  ) : null} 
                 </div> 
              </Card>
            </div>
            </div>
          </>
       </>
       
      {AuthService.loggedIn() && (
          <Card
          className="p-4 "
          style={{
          //  marginTop: '5%',
           marginBottom: '5%',
           marginRight: '25%',
           marginLeft: '25%',
           width: 'auto',       
           display: 'block',  
           overflow: 'hidden',
           boxSizing: 'border-box', 
         }}>
        <div className="row gy-4">
          {isEditing && (
            <>
            <div className='col col-md-6 col-lg-6 d-flex flex-column'>
            <Button 
              className="process-card-text hover-brighten-green"
              style={{
                display: 'block',
                height: 'auto',
                width: 'auto',
                margin: '5px auto',
                fontSize: '2.5vmin',
                backgroundColor: 'rgb(0, 128, 0)',
                color: '#fff',
                border: '2px solid rgba(28, 26, 26, 0.9)',
                boxShadow: `
                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                  0 12px 24px rgba(0, 0, 0, 0.6),
                  0 32px 64px rgba(0, 0, 0, 0.5),
                  0 64px 100px rgba(0, 0, 0, 0.35)
                `,
                borderRadius: '999px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
              onClick={handleSaveChanges}
              >
              <h5 style={{ margin: '1%' }}>Save</h5>
            </Button>
            </div>
            </>
            
          
          )}
          {canEdit && (
            <>
            <div className={`col d-flex flex-column ${!isEditing ? 'col-12' : 'col-md-6 col-lg-6'}`}>
            <Button
              className={`process-card-text ${!isEditing ? 'hover-brighten' : 'hover-brighten-red'}`}
              style={{
                display: 'block',
                height: 'auto',
                width: 'auto',
                margin: '5px auto',
                fontSize: '2.5vmin',
                backgroundColor: !isEditing ? 'rgb(67, 66, 66)': 'red',
                color: !isEditing ? 'silver': '#fff',
                border: '2px solid rgba(28, 26, 26, 0.9)',
                boxShadow: `
                  0 2px 0 rgba(255, 255, 255, 0.03) inset,
                  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                  0 12px 24px rgba(0, 0, 0, 0.6),
                  0 32px 64px rgba(0, 0, 0, 0.5),
                  0 64px 100px rgba(0, 0, 0, 0.35)
                `,
                borderRadius: '999px',
                cursor: 'pointer',
                textAlign: 'center',
              }}
              onClick={() => {
                if (isEditing) {
                  
                  setFormState(originalData); 
                } else {
                  setOriginalData(formState);
                }
                setIsEditing((prev) => !prev); 
              }}
              disabled={!canEdit}
            >
              <h5 style={{ margin: '1%' }}>
                {isEditing ? 'Cancel' : 'Edit Profile'}
              </h5>
            </Button>
            </div>
            </>
          )}
        </div>
        </Card>
      )}  

  </div>
 );

}

export default CrewProfile;